import {
  CURRENCY_ADD_REQUEST,
  CURRENCY_ADD_REQUEST_FAILURE,
  CURRENCY_ADD_REQUEST_SUCCESS,
  CURRENCY_CLEAN_REQUEST,
  CURRENCY_FETCH_REQUEST,
  CURRENCY_FETCH_REQUEST_FAILURE,
  CURRENCY_FETCH_REQUEST_SUCCESS,
  CURRENCY_UPDATE_REQUEST,
  CURRENCY_UPDATE_REQUEST_FAILURE,
  CURRENCY_UPDATE_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const currenciesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CURRENCY_ADD_REQUEST:
    case CURRENCY_UPDATE_REQUEST:
    case CURRENCY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CURRENCY_ADD_REQUEST_SUCCESS:
    case CURRENCY_UPDATE_REQUEST_SUCCESS:
    case CURRENCY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.current || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case CURRENCY_ADD_REQUEST_FAILURE:
    case CURRENCY_UPDATE_REQUEST_FAILURE:
    case CURRENCY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
          showSizeChanger: true,
        },
      });

    case CURRENCY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
          showSizeChanger: true,
        },
      });

    default:
      return state;
  }
};

export default currenciesReducer;
